import moment from 'moment'

export default {
  methods: {
    showDiffInTermFormat(date1, date2)
    {
      if (
          date1 === '' ||
          date1 === null ||
          date2 === '' ||
          date2 === null
    )
      {
        return '-'
      }
      let result = ''
      const a = moment(date1)
      const b = moment(date2)
      const years = a.diff(b, 'year')
      b.add(years, 'years')

      const months = a.diff(b, 'months')
      b.add(months, 'months')

      const days = a.diff(b, 'days')

      if (years)
      {
        result += years + this.$t('dates.y')
      }
      if (months)
      {
        result += months + this.$t('dates.m')
      }
      if (days)
      {
        result += days + this.$t('dates.d')
      }

      // Late (minus) dates
      if (years < 0 || months < 0 || days < 0)
      {
        result = this.$t('dates.late')
      }

      // fore equal/today date comparison
      if (!years && !months && !days)
      {
        result = '0 ' + this.$t('dates.d')
      }
      return result
    },
    showDateInDotFormat(d)
    {
      try
      {
        return d ? moment(d).format('DD.MM.YYYY') : '-'
      }
      catch (e)
      {
        console.log('failed show date in dot format ', e)
      }
    },
    getDateInFormat(date, format, oldFormat = null)
    {
      const inputDate = moment(date, oldFormat)
      return inputDate.format(format)
    },
    getToday()
    {
      return moment().format('DD.MM.YYYY')
    }
  }
}
